import React, { useEffect, useState } from 'react';
import { getLocalPdfUrl } from '@whelk/services/src/file';
import { Loading } from './Loading';

export function Pdf(props: { url: string }) {
  const { url } = props;
  const [loadUrl, setLoadUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const encodeUrl = loadUrl;

  const fetchLocalUrl = async () => {
    try {
      setLoading(true);
      const localUrl = await getLocalPdfUrl(url);
      setLoadUrl(localUrl);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocalUrl();
  }, [url]);

  if (loading) {
    return <Loading />;
  }
  return (
    <iframe
      className='h-full w-full rounded-b-[16px]'
      src={`/pdf/web/viewer.html?file=${encodeUrl}`}
    />
  );
}
